module.exports = exchanges;